import React from 'react';
import Link from '../common/TrackedLink';

const Retailer = ({ retailer }) => {
	const { name, url, region } = retailer;
	const image = require(`../../resources/img/where-to-buy/${retailer.image}`);
	return (
		<li>
			<Link
				to={ url } target="_blank"
				trackEvent="Where to Buy"
				trackEventAction={ region }
				trackEventLabel={ name }
			>
				<img src={ image } alt={ name } title={ name } />
			</Link>
		</li>
	);
};

export default Retailer;


// WEBPACK FOOTER //
// ./src/pages/whereToBuy/Retailer.js